module.exports = __webpack_public_path__ + "static/holisent_logo-d5ce79680fb65be933c675125fc8b509.svg";